import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import TierPromotionCard from '../../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../../TierPromotionCardWithFellaTooltip';
import { getBiDataForTierLink } from '../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import { getTranslationKeyForAccessibleDeviationLink } from '../../helpers';
import s from './Tier.scss';
var Tier = function (_a) {
    var deviation = _a.deviation, width = _a.width, height = _a.height, className = _a.className, style = _a.style, showTierPromotionTooltip = _a.showTierPromotionTooltip;
    var t = useTranslation().t;
    var a11yLabel = getTranslationKeyForAccessibleDeviationLink(t, deviation);
    var biData = getBiDataForTierLink(deviation);
    return (React.createElement("div", { style: __assign({ width: width, height: height }, style), className: classnames(s['root'], className) },
        showTierPromotionTooltip ? (React.createElement(TierPromotionCardWithFellaTooltip, { deviation: deviation, width: width, height: height })) : (React.createElement(TierPromotionCard, { deviation: deviation, width: width, height: height })),
        React.createElement(BiLink, { className: s['link-overlay'], biData: biData, "aria-label": a11yLabel, href: Url.userSubscriptionsPath({
                username: deviation.author.username,
                tierDeviationId: deviation.deviationId,
                tierContentType: 'deviations',
            }) },
            React.createElement("span", null))));
};
Tier.displayName = 'TierThumb';
export default Tier;
//# sourceMappingURL=Tier.js.map